import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=3a03cfbf&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=3a03cfbf&prod&scoped=true&lang=css"
import style1 from "./VideoGallery.vue?vue&type=style&index=1&id=3a03cfbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a03cfbf",
  null
  
)

export default component.exports